import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useHistory } from 'react-router-dom';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import Button from '@swf/components/StarsButton/StarsButton';
import BankId from '@swf/core/assets/icons/bankid.svg';

import {
  TXTCLI_Continue_without_BankID,
  TXTCLI_Sign_up_with_BankID_for_quick__ELL,
  TXTCLI_Signup_with_BankID,
  TXTWCL_Already_have_a_Stars_IDX_login_ELL
} from './RegistrationBankId.messages.json';
import styles from './RegistrationBankId.scss';

const RegistrationBankId: React.FC = () => {
  const { push } = useHistory();
  const openLogin = () => push('/auth/login');
  const openRegistrationWithBankId = () => push('/auth/registration', { bankId: true });
  const openRegistration = () => push('/auth/registration');

  return (
    <>
      <div className={styles.center}>
        <BankId width={90} height={90} />
        <Translation tagName="p" {...TXTCLI_Sign_up_with_BankID_for_quick__ELL} />
      </div>
      <ButtonGroup>
        <Button onClick={openRegistrationWithBankId} translation={TXTCLI_Signup_with_BankID} />
        <Button
          variant="secondary"
          onClick={openRegistration}
          translation={TXTCLI_Continue_without_BankID}
        />
        <Button
          variant="text"
          onClick={openLogin}
          translation={TXTWCL_Already_have_a_Stars_IDX_login_ELL}
        />
      </ButtonGroup>
    </>
  );
};

export default RegistrationBankId;
